import React, { FC } from "react";
import {Banner} from "@jobber/components/Banner";

type ErrorBannerProps = {
    message: string,
    onRetry?: () => void,
};

const ErrorBanner: FC<ErrorBannerProps> = ({
    message,
    onRetry,
}) => {
    return (
        <Banner
            type={"error"}
            icon={"alert"}
            primaryAction={{
                label: "Try Again",
                onClick: onRetry ?? (() => window.location.reload()),
            }}
        >
            {message}
        </Banner>
    );
};

export default ErrorBanner;